import { UnstyledButton } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';

import useStyles from './SubHeader.styles';
import type { WidgetItem, WidgetAction } from './types';

function SubHeaderWidget({ items, actions, opacity }: {
  items: WidgetItem[],
  actions: WidgetAction[],
  opacity: number,
}) {
  const { classes } = useStyles({});

  if ((!items && !actions) || (items?.length === 0 && actions?.length === 0)) return;

  return (
    // eslint-disable-next-line react/forbid-dom-props -- scroll-driven per-frame value; a createStyles parameter would emit a class per value
    <div className={classes.subHeaderWidget} style={{ opacity }}>
      {items?.length > 0 && items.map((item) => (
        <div className={classes.widgetColumn} key={item.label}>
          <Text variant="subhead-x-small" c="gray2.3">{item.label}</Text>
          <Text variant="subhead-large">{item.value}</Text>
          {item.sublabel && (
            <Text
              variant="subhead-small"
              c={item.isPositive ? 'teal.4' : 'red.5'}
            >
              {item.sublabel}
            </Text>
          )}
        </div>
      ))}

      {items?.length > 0 && actions?.length > 0 && (
        <div className={classes.widgetDivider} />
      )}

      {actions?.length > 0 && actions.map(({ Icon, ...action }) => (
        <UnstyledButton
          className={classes.widgetActionButton}
          key={action.label}
          onClick={action.onClick}
          aria-label={action.label}
        >
          <Icon size={24} />
        </UnstyledButton>
      ))}
    </div>
  )
}

export default SubHeaderWidget;
